import { LinearGradient } from 'expo-linear-gradient';
import React from 'react';
import { StyleSheet, Text, View } from 'react-native';

interface MedalTierProps {
  icon: any;
  title: string;
  range: string;
  isHighlighted: boolean;
}

export default function MedalTier({
  icon: Icon,
  title,
  range,
  isHighlighted,
}: MedalTierProps) {
  return (
    <View style={styles.medalCard}>
      {isHighlighted && (
        <LinearGradient
          colors={['rgba(131, 191, 79, 0.65)', 'rgba(131, 191, 79, 0.5)']}
          style={styles.medalHighlightGradient}
        />
      )}
      <View style={styles.medalIconContainer}>
        <Icon width={24} height={24} />
      </View>
      <View style={styles.medalInfo}>
        <Text
          style={[
            styles.medalTitle,
            isHighlighted && styles.medalTextHighlight,
          ]}
        >
          {title}
        </Text>
        <Text
          style={[styles.medalRange, isHighlighted && styles.medalTextHighlight]}
        >
          {range}
        </Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  medalCard: {
    backgroundColor: '#FFF',
    paddingHorizontal: 16,
    paddingVertical: 6,
    flexDirection: 'row',
    alignItems: 'center',
    position: 'relative',
    overflow: 'hidden',
  },
  medalHighlightGradient: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
  medalIconContainer: {
    width: 40,
    height: 40,
    marginRight: 12,
    justifyContent: 'center',
    alignItems: 'center',
  },
  medalInfo: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  medalTitle: {
    fontFamily: 'Inter_700Bold',
    fontSize: 14,
    color: '#000',
  },
  medalRange: {
    fontFamily: 'Inter_600SemiBold',
    fontSize: 12,
    color: '#666',
  },
  medalTextHighlight: {
    color: '#FFF',
  },
});
